(ns kyber.events.dom-event-map)

(def dom-tags
  {:activity-control-bar-rewind
   {:doc (str "Icon in the activity timeline that allows users to rewind the "
              "PLO video.")
    :name "Activity Control Bar Rewind Button"}

   :activity-control-bar-play-pause
   {:doc (str "Icon in the activity timeline that allows users to play or "
              "pause the PLO video depending on the state of the video. (Play "
              "icon shows when video is paused.)")
    :name "Activity Control Bar Play / Pause Button"}

   :activity-control-bar-playback-rate
   {:doc (str "Icon in the activity timeline that allows users to adjust the "
              "PLO video playback rate.")
    :name "Activity Control Bar Playback Rate Button"}

   :activity-control-bar-volume
   {:doc (str "Icon in the activity timeline that displays the volume "
              "controls to adjust the PLO video volume.")
    :name "Activity Control Bar Volume"}

   :activity-control-bar-timeline
   {:doc (str "The UI component that allows users to scrub the video and "
              "displays learning moment markers.")
    :name "Activity Control Bar Timeline"}

   :activity-control-bar-timeline-marker
   {:doc (str "The UI component that lives in the 'Activity Control Bar "
              "Timeline' and represents a moment in the learning stream.")
    :name "Activity Control Bar Timeline Marker"}

   :activity-control-bar-learner-stream-button
   {:doc (str "Button in the 'Activity Control Bar' that triggers the "
              "learning stream to open.")
    :name "Activity Control Bar Learner Stream Button"}

   :active-moment-continue-button
   {:doc (str "Continue button on the active moment that dismisses the active "
              "moment")
    :name "Active Moment Continue Button"}

   :active-moment-note-button
   {:doc (str "Add / edit note button on the active moment that opens the "
              "learning stream to the moment in edit mode.")
    :name "Active Moment Note Button"}

   :activity-splash-start-from-beginning-button
   {:doc (str "Start from beginning button on the activity splash page "
              "(subsequent visits)")
    :name "Activity Splash Start From Beginning Button"}

   :activity-splash-resume-button
   {:doc (str "Resume button on the activity splash page (subsequent "
              "visits)")
    :name "Activity Splash Resume Button"}

   :activity-splash-watch-segment-button
   {:doc "Watch segment button on the activity splash page"
    :name "Activity Splash Watch Segment Button"}

   :activity-splash-start-activity-link
   {:doc (str "Link on the activity splash page that starts the video "
              "(initial visit)")
    :name "Activity Splash Start Activity Link"}

   :activity-splash-start-activity-icon
   {:doc (str "Icon on the activity splash page that starts the video "
              "(initial visit)")
    :name "Activity Splash Start Activity Icon"}

   :floating-learning-stream-button
   {:doc "Icon to open the learning stream in the PDF as PLO activities."
    :name "Floating Learning Stream Button"}

   :take-note-button
   {:doc "The ever-present button that triggers the notepad to open."
    :name "Ever-present Take Note Button"}

   :learning-stream-card
   {:doc (str "The card displayed in the learning stream sidebar representing "
              "a moments contents")
    :name "Learning Stream Card"}

   :learning-stream-note-button
   {:doc "The add note button that renders in the open learning stream."
    :name "Learning Stream Note Button"}

   :learning-stream-close-button
   {:doc (str "Button that renders in the learning stream that is responsible "
              "for closing the learning stream.")
    :name "Learning Stream Close Button"}

   :learning-stream-resume-video
   {:doc (str "Section of the learning stream that renders the Play / Resume "
              "video component. This is the component that renders between "
              "learning moments depending on current video position.")
    :name "Learning Stream Resume Video"}

   :learning-stream-view-in-document
   {:doc (str "Section of the learning stream that renders the Resume "
              "in document component. This is the component that renders "
              "between learning moments depending on current page.")
    :name "Learning Stream Resume In Document Button"}

   :learning-stream-card-collapsed-view-in-video-cta
   {:doc "View in video CTA that displays in the 'Learning Stream Card'."
    :name "Learning Stream Card View In Video CTA"}

   :learning-stream-card-collapsed-view-in-document-cta
   {:doc "View in document CTA that displays in the 'Learning Stream Card'."
    :name "Learning Stream Card View In Document CTA"}

   :learning-stream-card-collapsed-expand-card-cta
   {:doc "View in video CTA that displays in the 'Learning Stream Card'."
    :name "Learning Stream Card Expand Card CTA"}

   :learning-stream-card-expanded-view-in-video-button
   {:doc (str "View in video button that is displayed in an expanded learning "
              "stream card.")
    :name "Learning Stream Card Expanded View In Video Button"}

   :learning-stream-card-expanded-view-in-document-button
   {:doc (str "View in document button that is displayed in an expanded "
              "learning stream card.")
    :name "Learning Stream Card Expanded View In Documnet Button"}

   :learning-stream-card-expanded-edit-note-button
   {:doc "Edit note button displayed in an expanded learning stream card."
    :name "Learning Stream Card Expanded Edit Note Button"}

   :learning-stream-card-expanded-add-note-button
   {:doc (str "Add note button rendered in the expanded learning stream card "
              "that will move the current moment into an editing state to add "
              "a note.")
    :name "Learning Stream Card Expanded Add Note Button"}

   :learning-stream-card-answer-question-button
   {:doc (str "Answer question link button that appears in the footer of a "
              "learning stream card when the question is unanswered and the "
              "card is collapsed.")
    :name "Learning Stream Card Answer Question Link Button"}

   :learning-stream-card-shout-dismiss-button
   {:doc (str "Answer later link button displayed in the footer of the "
              "learning stream card when the moment's behavior is a 'shout'")
    :name "Learning Stream Card Review Later Link Button"}

   :learning-stream-card-expand-toggle-button
   {:doc (str "Expand  button rendered in the footer of the learning"
              "stream card that expands or collapses the learning stream card.")
    :name "Learning Stream Card Expand Toggle Button"}

   :media-control-bar-rewind
   {:doc "Icon in the media control bar that rewinds the media 15 seconds"
    :name "Media Control Bar Rewind Button"}

   :media-control-bar-play-pause
   {:doc "Icon in the media control bar play / pause button"
    :name "Media Control Bar Play / Pause Button"}

   :media-control-bar-playback-rate
   {:doc "Icon in the media control bar that controls playback rate"
    :name "Media Control Bar Playback Rate Button"}

   :media-control-bar-scrubber
   {:doc (str "Slider in the media control bar that controls the position "
              "of the media playback.")
    :name "Media Control Bar Scrubber"}

   :media-control-bar-volume
   {:doc "Icon in the media control bar that controls volume"
    :name "Media Control Bar Volume"}

   :question-binary-choice-selection
   {:doc "Selection input for a 'binary' question type"
    :name "Question Binary Choice Select"}

   :question-binary-choice-selection-label
   {:doc "Selection input for a 'binary' question type (Label)"
    :name "Question Binary Choice Select Label"}

   :question-multiple-answer-choice-selection
   {:doc "Selection input for a 'multiple-answer' question type"
    :name "Question Multiple Answer Choice Selection"}

   :question-multiple-answer-choice-selection-label
   {:doc "Selection input for a 'multiple-answer' question type (Label)"
    :name "Question Multiple Answer Choice Selection Label"}

   :question-single-answer-choice-selection
   {:doc "Selection input for a 'single-answer' question type"
    :name "Question Single Answer Choice Selection"}

   :question-single-answer-choice-selection-label
   {:doc "Selection input for a 'single-answer' question type (Label)"
    :name "Question Single Answer Choice Selection Label"}

   :question-free-response-input
   {:doc (str "Textarea that displays for a users to enter their "
              "'free-response' answer.")
    :name "Question Free Response Input"}

   :question-rating-scale-answer-choice-selection
   {:doc "Selection input for a 'rating scale question' question type"
    :name "Question Rating Scale Question Choice Selection"}

   :question-rating-scale-answer-selection-label
   {:doc "Selection input for a 'rating-scale' question type"
    :name "Question Rating Scale Answer Choice Selection Label"}

   :question-submit-guess-button
   {:doc (str "Submit button for a moment question that submits the "
              "question with a confidence of 'guess'")
    :name "Question Submit Guess Button"}

   :question-submit-unsure-button
   {:doc (str "Submit button for a moment question that submits the "
              "question with a confidence of 'unsure'")
    :name "Question Submit Unsure Button"}

   :question-submit-sure-button
   {:doc (str "Submit button for a moment question that submits the "
              "question with a confidence of 'sure'")
    :name "Question Submit Sure Button"}

   :question-submit-button
   {:doc (str "Submit button for a moment question that submits the "
              "question without a confidence")
    :name "Question Submit Guess Button"}

   :notepad-add-video-still-button
   {:doc "Add video still button on the notepad"
    :name "Notepad Add Video Still Button"}

   :notepad-remove-video-still-button
   {:doc "Remove video still button on the notepad"
    :name "Notepad Remove Video Still Button"}

   :note-form-delete-note-button
   {:doc "Note Form's delete note CTA"
    :name "Note Form Delete Note Button"}

   :note-form-cancel-button
   {:doc (str "Note Form's cancel button. This indicates that a user is "
              "disregarding changes that they were making.")
    :name "Note Form Cancel Button"}

   :note-form-submit-note-button
   {:doc (str "Note Form's submit button. This indicates that a user is "
              "saving or editing a note.")
    :name "Note Form Submit Note Button"}

   :open-resource-library-button
   {:doc "Button in the bottom left that opens the resource library."
    :name "Open Resource Library Button"}

   :pdf-viewer-previous-page-button
   {:doc "Previous page navigation button on the PDF Viewer"
    :name "PDF Viewer Previous Page Button"}

   :pdf-viewer-next-page-button
   {:doc "Next page navigation button on the PDF Viewer"
    :name "PDF Viewer Next Page Button"}

   :pdf-viewer-increase-scale-button
   {:doc "Button that increase the scale of the PDF"
    :name "PDF Viewer Increase Scale Button"}

   :pdf-viewer-reduce-scale-button
   {:doc "Button that reduces the scale of the PDF"
    :name "PDF Viewer Reduce Scale Button"}

   :pdf-viewer-search-box
   {:doc "Search box for the PDV viewer"
    :name "PDF Viewer Search Box"}

   :pin-moment-button
   {:doc "Pin moment button"
    :name "Pin Moment Button"}

   :pin-resource-button
   {:doc "Pin resource button"
    :name "Pin Resource Button"}

   :unpin-moment-button
   {:doc "Unpin moment button"
    :name "Unpin Moment Button"}

   :unpin-resource-button
   {:doc "Unpin resource button"
    :name "Unpin Resource Button"}

   :questionnaire-tab-question-button
   {:doc "Tab question button on a questionnaire"
    :name "Questionnaire Tab Question Button"}

   :resource-preview-open-resource-viewer-link
   {:doc "Link that opens the resource in the resource viewer"
    :name "Resource Preview Open Resource Viewer Link"}

   :resource-preview-download-button
   {:doc "Download icon button that renders in the resource preview list."
    :name "Resource Preview Download Button"}

   :resource-viewer-download-button
   {:doc (str "Download icon button that renders in the resource viewer "
              "side panel")
    :name "Resource Viewer Download Button"}

   :resource-viewer-close-button
   {:doc (str "Button that is rendered in the resource viewer. When clicked "
              "removes the viewer resource and closed the viewer.")
    :name "Resource Viewer Close Button"}})
